<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-EPI">WHEN YOU OPERATE IN AN OVERBUILT METROPOLIS,<br/>YOU HAVE TO HACK YOUR WAY WITH A MEAT AX.</p>
<p class="ORIM-EPIC">—ROBERT MOSES</p>
<p class="ORIM-EPI">THE FIRST DUTY IN LIFE IS TO ASSUME A POSE.<br/>WHAT THE SECOND IS, NO ONE HAS YET DISCOVERED.</p>
<p class="ORIM-EPIC">—OSCAR WILDE</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Fussell_Muscle_4P_MD5.vue?882c4e80